import React from 'react';

// Translation in portal
export const TranslateContext = React.createContext(null);

